<script setup lang="ts">
import AppShell from "../Layout/AppShell.vue"
import PurchaseOrderForm from "./components/PurchaseOrderForm.vue"

defineProps<{
  purchase_order: {
    id: number
    company_id: number | ""
    supplier_id: number | ""
    status: string
    expected_at: string
    notes: string
    items: Array<{
      id?: number | null
      product_id: number | ""
      quantity: string
      unit_price_cents: string
      ipi: string
      icms: string
    }>
  }
  suppliers: Array<{ label: string; value: number }>
  products: Array<{ label: string; value: number }>
  errors?: Record<string, string[]>
}>()
</script>

<template>
  <AppShell>
    <PurchaseOrderForm
      mode="edit"
      title="PurchaseOrders/PurchaseOrdersEdit"
      subtitle="Atualize o rascunho do pedido de compra antes do envio."
      :purchase-order="purchase_order"
      :suppliers="suppliers"
      :products="products"
      :errors="errors"
    />
  </AppShell>
</template>

